"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = _interopRequireDefault(require("../hooks/Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelImage = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    alt = 'Image',
    className = '',
    isSquare = false,
    loading,
    onClick,
    onError,
    onLoad,
    onMouseEnter,
    onMouseLeave,
    size,
    style = {},
    url
  } = props;
  const image = (0, _Image.default)(url, {
    size,
    isSquare
  });
  return /*#__PURE__*/_react.default.createElement("img", {
    alt: alt,
    className: className,
    loading: loading,
    onClick: onClick ? () => onClick() : undefined,
    onLoad: onLoad ? () => onLoad() : undefined,
    onMouseEnter: onMouseEnter ? () => onMouseEnter() : undefined,
    onMouseLeave: onMouseLeave ? () => onMouseLeave() : undefined,
    onError: onError ? () => onError() : undefined,
    ref: ref,
    src: image,
    style: style
  });
});
BrixelImage.displayName = 'BrixelImage';
var _default = exports.default = BrixelImage;